import React, { useContext } from "react";
import {  Spin, } from "antd";
import {
  LoadingOutlined,
} from "@ant-design/icons";
import useExpertDashboard from "PlatForms/Dashboards/ExpertDashboard/Hooks/useExpertDashboard";
import { ProfileContext } from "Common/hooks/context/ProfileContext";
import ProfileIncompleteAlert from "Common/Components/ProfileIncompleteAlert";
import { ExpertHeader } from "./ExpertHeader";
import SkillstAlert from "../Skills/SkillsAlert";

const ExpertLandingPage = () => {
  const { isProfileComplete, loading: profileLoading } = useContext(ProfileContext);
  const { dashboardData, skills,loading, error } = useExpertDashboard();

  const spinnerIcon = <LoadingOutlined style={{ fontSize: 48, color: "#9A6B0E" }} spin />;

  if (loading || profileLoading) {
    return (
      <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "80vh" }}>
        <Spin indicator={spinnerIcon} />
        <div style={{ marginTop: 16, color: "#9A6B0E" }}>Loading...</div>
      </div>
    );
  }

  if (error || !dashboardData) {
    return <div style={{ padding: 20 }}>{error ? `⚠️ Error: ${error}` : "No data available"}</div>;
  }

  return (
    <div style={{ padding: "12px 24px" }}>
      {/* Passing learner data to Header for Image and Greeting */}
          <ExpertHeader 
      userName={`${dashboardData.expert.firstName} ${dashboardData.expert.lastName}`}
        expertCode={dashboardData.expert.expertCode} 

    />


      <div>
        {!isProfileComplete && <ProfileIncompleteAlert navigateTo="/expert-profile" />}
        
        <SkillstAlert skills={skills || []} />
       




     


      </div>
    </div>
  );
};

export default ExpertLandingPage;